import { useState } from 'react';
import React from 'react';
import { Form , Button} from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { Alert } from 'react-bootstrap';

function ModifTournoi(props) {
    const [nom, setNom] = useState(props.item.nomTournois);
    const [maxParticipants, setMaxParticipants] = useState(props.item.nbr_equipe);
    const [commentaire, setCommentaire] = useState(props.item.commentaire)
    const [lieu, setLieu] = useState(props.item.localisation)
    const [error, setError] = useState(false);
    const [confirmation,setConfirmation] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [date, setDate] = useState(props.item.date);
    const apiUrl = process.env.REACT_APP_API_URL;



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setConfirmation(false);
        
        try {
          await axios.patch(`${apiUrl}/tournois/informations/modifier`, {
            idTournois : props.item.id_tournoi,
            nom : nom,
            commentaire: commentaire,
            maxParticipants : maxParticipants,
            lieu : lieu, 
            date : date
          }, {
            withCredentials: true
          });
    
          setError(null);
          setIsLoading(false);
          window.location.reload(); 
  
        } catch (error) {
          if (error.response) {
            setIsLoading(false)
            setError(error.response.data.message);
          } else {
            setIsLoading(false)
            setError(true);
          }
        }
      };


      if (isLoading) {
        return (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
        
        );  
      }


  return (
    <>
    {error && <Alert variant="danger">{error}</Alert>}
    {confirmation && (
      <>
        <Modal show={confirmation} onHide={() => {setConfirmation(false);}}>
                <Modal.Header closeButton>
                  <Modal.Title>Modifier le tournoi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Voulez-vous vraiment modifier les informations du tournoi ?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => {setConfirmation(false);}} >
                    Quitter
                  </Button>
                  <Button variant="primary" onClick={(e) => handleSubmit(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                    Modifier
                  </Button>
                </Modal.Footer>
        </Modal>
      </>
    )}
    {props.item && (
                                <Form >
                                    <Form.Label>Nom du tournoi</Form.Label>
                                    <Form.Control type="text" placeholder="Entrez le nom du tournoi" value={nom} onChange={(e) => setNom(e.target.value)}/>            
                                    <br/>
                                    <Form.Label>Lieu du tournoi</Form.Label>
                                    <Form.Control type="text" placeholder="Entrez le lieu du tournoi" value={lieu} onChange={(e) => setLieu(e.target.value)}/>
                                    <br/>
                                    <Form.Label>Date du tournoi</Form.Label>
                                    <br/>
                                    <input name="date_debut"  onChange={(e) => setDate(e.target.value)}type="date" id="date_debut" value={date} style={{width: '100%', borderRadius : '5px'}}/>
                                    <br/><br/>
                                    <Form.Label>Nombre maximum de participants (Remarque : retirer votre équipe de ce nombre)</Form.Label>
                                    <Form.Control type="number" placeholder="Entrez le nombre maximum de participants"  onChange={(e) => setMaxParticipants(e.target.value)} value={maxParticipants}/>
                                    <br/>
                                    <Form.Label>Commentaire</Form.Label>
                                    <Form.Control as="textarea" placeholder="Ajoutez un commentaire" value={commentaire}  onChange={(e) => setCommentaire(e.target.value)}  rows={3} />
                                    <br/>
                                    <div style={{textAlign:"right"}}>
                                        <Button variant="secondary" onClick={() => {setConfirmation(true);}}>
                                            Modifier
                                        </Button>
                                    </div>
                                </Form>
            )}
    </>
  );
}

export default ModifTournoi;